<template>
  <div class="SingleUploadFile-container">
    <el-upload
      ref="singleUploadFile"
      :action="uploadFile"
      :accept="accept"
      :on-remove="handleRemove"
      :before-remove="beforeRemove"
      :on-success="successMultiFile"
      :on-error="errorMultiFile"
      :limit="2"
      :file-list="fList">
      <el-button size="small" icon="el-icon-upload2">点击上传</el-button>
      <span slot="tip" class="el-upload__tip" style="color:#99a9bf;margin-left: 10px">{{tip}}</span>
    </el-upload>
  </div>
</template>

<script>
export default {
  name: 'SingleFile',
  props: {
    old: {
      type: Array
    },
    tip: {
      type: String
    },
    accept: {
      type: String
    }
  },
  data() {
    return {
      uploadFile: process.env.VUE_APP_BASE_API + '/fileUpload/uploadFile',
      fileid: '',
      fList: []
    }
  },
  created() {
    if (this.old !== undefined) {
      if (this.old.length > 0) {
        for (let i of this.old) {
          if (i.id !== undefined && i.id !== null) {
            this.fileid = i.id
            this.fList = this.old
          }
        }
        this.$emit('input', this.fileid)
        this.$emit('change', this.fList)
      }
    }
  },
  methods: {
    handleRemove(file, fileList) {
      this.fList = []
      this.fileid = ''
      this.$emit('input', this.fileid)
      this.$emit('change', this.fList)
    },
    errorMultiFile() {
      this.$message({
        type: 'error',
        message: '文件上传失败，请稍后重试'
      })
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${ file.name } ？`)
    },
    successMultiFile(response, file, fileList) {
      this.fList = []
      if (response.success) {
        this.fList.push({ ...file, id: response.data.dFileid, name: response.data.dName + '.' + response.data.dType, url: response.data.file_url })
        this.fileid = response.data.dFileid
        this.$emit('input', this.fileid)
        this.$emit('change', this.fList)
      } else {
        this.$message({
          type: 'error',
          message: response.msg
        })
      }
    },
    clearSingleFile() {
      this.fList = []
      this.fileid = ''
      this.$emit('input', this.fileid)
      this.$refs['singleUploadFile'].clearFiles()
    },

  }
}
</script>

<style scoped>

</style>
